<template>
  <div class="select-region">
    <div class="dialog">
      <div class="dialog-title">{{ $t("message.select_region") }}</div>
      <div class="rect" @click="currentState = 'EURO'" :class="{ outline: currentState !== 'EURO' }">
        {{ $t("message.europe") }}
      </div>
      <div class="rect" @click="currentState = 'AME'" :class="{ outline: currentState !== 'AME' }">
        {{ $t("message.america") }}
      </div>
      <div class="tip">{{ $t("message.region_tip") }}</div>
      <div class="rect" @click="confirmRegionSelect">
        {{ $t("message.confirm_select") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentState: "EURO",
    };
  },
  emits: ["confirm"],
  methods: {
    confirmRegionSelect() {
      localStorage.setItem("selected_region", this.currentState);
      this.$emit("confirm", this.currentState);
    },
  },
  mounted() {
    this.currentState = localStorage.getItem("selected_region") || "EURO";
  },
};
</script>

<style lang="scss" scoped>
.select-region {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  overflow: auto;

  .dialog {
    width: 428px;
    background: white;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    .dialog-title {
      font-size: 30px;
      line-height: 40px;
      color: #000;
      margin-top: 10px;
    }

    .rect {
      width: 200px;
      height: 60px;
      background: linear-gradient(to right, #f09894, #e1685e);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      cursor: pointer;
      border-radius: 10px;

      &.outline {
        border: 1px solid #000;
        background: #fff;
        color: #000;
        box-sizing: border-box;
      }
    }

    .tip {
      color: #e44759;
      font-size: 20px;
      display: flex;
      align-items: center;
      line-height: 20px;
      height: 50px;
      text-align: center;
    }
  }
}

.mldy {
  .select-region {
    .dialog {
      padding: 0.2rem;
      width: 6rem;
      gap: 0.1rem;
      border-radius: 0.1rem;

      .dialog-title {
        font-size: 0.5rem;
      }

      .rect {
        font-size: 0.3rem;
        width: 2.5rem;
        height: 0.8rem;
        border-radius: 0.1rem;
      }

      .tip {
        line-height: 0.3rem;
        font-size: 0.3rem;
        height: 1rem;
      }
    }
  }
}
</style>
